// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggle[data-v-4d3433ba] {\n  color: var(--magic-tertiary, #311261);\n}\n.toggle[data-v-4d3433ba]:hover, .toggle[data-v-4d3433ba]:focus, .toggle[data-v-4d3433ba]:active {\n  color: #452970;\n}", ""]);
// Exports
module.exports = exports;
